/**
 * Reusable component for editing quesitons and answers
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import third-party libraries
import _ from 'lodash';
import classNames from 'classnames';
import questionStyles from '../../question/questionModuleStyles.css';

const AdminAnswer = ({
  answer
  , handleDelete
  , openModal
  , type
}) => {
  return (
    <div styleName="-answer" className="answer">
      { answer.correct && type === 'single' ?
        <i className="fas fa-check-circle"/>
        : !answer.corred && type === 'single' ?
        <i className="fal fa-circle"/>
        : answer.correct && type === 'multiple' ?
        <i className="fas fa-check-square"/>
        :
        <i className="fal fa-square"/>
      }
      <span> {answer.content}</span>
      <small styleName="-edit-answer-link" className="action-link" onClick={() => openModal(answer)}> &mdash; <em> Edit </em> </small>
      <small styleName="-edit-answer-link" className="action-link -danger" onClick={() => handleDelete(answer._id)}> <em> Delete</em></small>
    </div>
  )
}

AdminAnswer.propTypes = {
  answer: PropTypes.object.isRequired
  , handleDelete: PropTypes.func.isRequired
  , openModal: PropTypes.func.isRequired
  , type: PropTypes.oneOf(['single','multiple'])
}

AdminAnswer.defaultProps = {
  type: 'single'
}

export default AdminAnswer;



// WEBPACK FOOTER //
// modules/answer/components/AdminAnswer.js.jsx